import { ReactNode } from 'react'
import { useIsDesktop } from '../../hooks'
import { MobileLayout } from './MobileLayout'
import { DesktopLayout } from './DesktopLayout'

interface ResponsiveLayoutProps {
  children: ReactNode
  title?: string
}

export function ResponsiveLayout({ children, title }: ResponsiveLayoutProps) {
  const isDesktop = useIsDesktop()

  if (isDesktop) {
    return <DesktopLayout>{children}</DesktopLayout>
  }

  return <MobileLayout title={title}>{children}</MobileLayout>
}
